import { render, staticRenderFns } from "./Novedades.vue?vue&type=template&id=327a42b9&"
import script from "./Novedades.vue?vue&type=script&lang=js&"
export * from "./Novedades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports